import React from 'react';
import { generatePath, Link, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Box, Breadcrumbs } from '@mui/material';
import { Home } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import Bluebird from 'bluebird';
import routes from '../../../../routes';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import { fetchFoodDonorPickupLocations, updateFoodDonorPickupLocation } from '../../../../actions/foodDonors';
import snackbarHelper from '../../../../helpers/snackbarHelper';
import FoodDonorPickupLocationEditForm from '../../../../components/FoodDonorPickupLocationEditForm';

const FoodDonorMobileLocationEditBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<Home style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboardFoodDonorLocations)}
          label={formatMessage({ id: 'breadcrumbs.food-donor-locations' })}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.food-donor-location-edit' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const FoodDonorMobilePickupLocationEdit = ({ location, foodDonorId }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onUpdateFoodDonorPickupLocation = (data) =>
    Bluebird.try(() => dispatch(updateFoodDonorPickupLocation(foodDonorId, location.id, data)))
      .then(() => dispatch(fetchFoodDonorPickupLocations(foodDonorId)))
      .then(() => {
        snackbarHelper.success('Pickup Location updated successfully!');

        return history.push(generatePath(routes.mobileDashboardFoodDonorLocations));
      });

  if (!location?.id || !foodDonorId) {
    return history.push(generatePath(routes.mobileDashboardFoodDonorLocations));
  }

  return (
    <>
      <FoodDonorMobileLocationEditBreadcrumb />

      <Box py={2} px={1}>
        <FoodDonorPickupLocationEditForm
          isMobile
          foodDonorPickupLocation={location}
          updateFoodDonorPickupLocation={onUpdateFoodDonorPickupLocation}
        />
      </Box>
    </>
  );
};

export default FoodDonorMobilePickupLocationEdit;
